// extracted by mini-css-extract-plugin
export default {"settingsWrapper":"styles_settingsWrapper__T7jnU","title":"styles_title__2zvhF","adminView":"styles_adminView__R6erM"};